export const contactDescriptionStyles = {
  wrapper: {
    textAlign: {
      mobile: "center",
      tablet: "left",
    },
    width: {
      tablet: "60ch",
      laptop: "45ch",
      desktop: "50ch",
    },
    mb: "3rem",
  },
  title: {
    color: "white.main",
  },
  text: {
    color: "white.main",
    mt: {
      mobile: "1.5rem",
    },
  },
};
